export default __webpack_public_path__ + "static/media/powell-cat.955fc500.png";